export default "__VITE_ASSET__BvkyAeoi__"